import React from 'react'
import HtmlBodyWrapper from "./HtmlBodyWrapper"
import HtmlHead from './HtmlHead'
import HtmlWrapper from "./HtmlWrapper"
import Newsletter from "./Newsletter"


const HtmlNewsletter = ({title, stylesData, structureData, cinemaData, newsletterData, ads, highlights, movieData, stylesFontFaces, closingTextLines, translation, imageItems, textItems, socialMediaData, currentCinemaUrl}) => (
    <HtmlWrapper>
        <HtmlHead 
            title={title}
            stylesFontFaces={stylesFontFaces}
        />
        <HtmlBodyWrapper backgroundBody={stylesData.accent_color_background}>
            <Newsletter 
                stylesData={stylesData}
                structureData={structureData}
                cinemaData={cinemaData}
                imageItems={imageItems}
                textItems={textItems}
                socialMediaData={socialMediaData}
                currentCinemaUrl={currentCinemaUrl}
                newsletterData={newsletterData}
                ads={ads}
                highlights={highlights}
                movieData={movieData}
                closingTextLines={closingTextLines}
                translation={translation}
            />
        </HtmlBodyWrapper>
    </HtmlWrapper>
)


export default HtmlNewsletter